import React from 'react';
import AppListToolbarGlobal, { type CompanyOption } from '@/__core/components/AppLisstToolbarGlobal';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import { sharedToolbarListStyles } from '@/__core/styles';

export interface ReturnsToolbarGlobalProps {
  /** @deprecated Chỉ dùng khi test; mặc định lấy từ auth + resolveModuleAccessibleCompanies */
  companies?: CompanyOption[];
  fetchCompanies?: () => Promise<CompanyOption[]>;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: () => void;
  onToggleAdvancedSearch?: () => void;
  isAdvancedSearchOpen?: boolean;
  onFilterChange?: (field: string, value: string) => void;

  filters?: {
    company: string;
    status: string;
  };
  statusOptions?: Array<{ id: string; name: string }>;
  onRefresh?: () => void;
}

export default function ReturnsToolbarGlobal({
  companies,
  searchQuery = '',
  onSearchChange,
  onSearchSubmit,
  onToggleAdvancedSearch,
  isAdvancedSearchOpen = false,
  filters = { company: 'all', status: 'all' },
  onFilterChange,
  statusOptions = [],
  onRefresh,
}: ReturnsToolbarGlobalProps) {
  const statusFilterOptions = React.useMemo(
    () => statusOptions.map((option) => ({ value: option.id, label: option.name })),
    [statusOptions]
  );

  const advancedFilterFields = React.useMemo(
    () => [
      {
        key: 'status',
        label: 'Trạng thái',
        labelWidth: 90,
        value: filters.status,
        placeholder: 'Chọn trạng thái',
        options: statusFilterOptions,
        onChange: (value: string) => onFilterChange?.('status', value),
        gridSize: { xs: 12, sm: 6, md: 6 },
      },
    ],
    [filters.status, onFilterChange, statusFilterOptions]
  );

  const rightActions = onRefresh ? (
    <Tooltip title='Làm mới' arrow>
      <IconButton
        onClick={onRefresh}
        size='small'
        sx={{
          ...sharedToolbarListStyles.actionIconButtonBase,
          backgroundColor: '#10b981',
          borderColor: '#10b981',
          color: 'white',
          '&:hover': { backgroundColor: '#059669', borderColor: '#059669' },
        }}
      >
        <RefreshIcon sx={sharedToolbarListStyles.toolbarActionIcon} />
      </IconButton>
    </Tooltip>
  ) : null;

  return (
    <AppListToolbarGlobal
      scopeModule='returns'
      companies={companies}
      searchPlaceholder='Tìm theo mã hoàn trả, đơn hàng, kho...'
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      onSearchSubmit={onSearchSubmit}
      isAdvancedSearchOpen={isAdvancedSearchOpen}
      onToggleAdvancedSearch={onToggleAdvancedSearch}
      selectedCompany={filters.company}
      onCompanyChange={(id) => onFilterChange?.('company', id)}
      advancedFilterFields={advancedFilterFields}
      rightActions={rightActions}
    />
  );
}
